import gcpConfig from './gcp'
import alibabaConfig from './alibaba'
import tencentConfig from './tencent'
import akamaiConfig from './akamai'
import azureConfig from './azure'
import ociConfig from './oci'

const configs = {
  gcp: gcpConfig,
  alibaba: alibabaConfig,
  tencent: tencentConfig,
  akamai: akamaiConfig,
  azure: azureConfig,
  oci: ociConfig,
}

export default configs[window.servicePlatform]
